import React from 'react';

/** Number of skeleton cards to show */
const SKELETON_COUNT = 6;

/**
 * AppsLoadingSkeleton Component
 * 
 * Displays animated placeholder cards while apps are loading.
 * Provides visual feedback and maintains layout stability.
 * 
 * @example
 * {isLoading ? <AppsLoadingSkeleton /> : <AppsGrid apps={apps} />}
 */
const AppsLoadingSkeleton: React.FC = () => {
    return (
        <div
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
            role="status"
            aria-label="Loading applications"
        >
            {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
                <div
                    key={index}
                    className="bg-white rounded-2xl p-6 shadow-sm animate-pulse"
                >
                    {/* Top accent bar skeleton */}
                    <div className="h-1 bg-gray-200 rounded-t-2xl -mx-6 -mt-6 mb-6" />

                    {/* Icon skeleton */}
                    <div className="w-16 h-16 bg-gray-200 rounded-xl mb-4" />

                    {/* Title skeleton */}
                    <div className="h-6 bg-gray-200 rounded w-3/4 mb-2" />

                    {/* Description skeleton */}
                    <div className="h-4 bg-gray-200 rounded w-full mb-2" />
                    <div className="h-4 bg-gray-200 rounded w-2/3" />
                </div>
            ))}

            {/* Screen reader text */}
            <span className="sr-only">Loading applications, please wait...</span>
        </div>
    );
};

export default AppsLoadingSkeleton;

